<template>
  <WTooltip :position="tooltipPosition" size="small" :label="tooltipText">
    <div>
      <div
        :class="{
          highlightDefault: !channelsHeader,
          highlightButton: channelsHeader,
          highlighted: shouldHighlight
        }"
      >
        <WIcon
          :icon="icon"
          data-testid="icon-highlight"
          @click.prevent.stop="toggleChannelHighlight"
        />
      </div>
    </div>
  </WTooltip>
</template>

<script>
import { WIcon, WTooltip } from '@alice-health/wonderland-vue'

export default {
  components: {
    WIcon,
    WTooltip
  },
  props: {
    channelId: { type: String, default: undefined },
    size: {
      type: String,
      default: 'large'
    },
    tooltipPosition: {
      type: String,
      default: 'top-end'
    },
    channelsHeader: Boolean,
    isHighlighted: {
      type: [Boolean, null],
      default: null
    }
  },
  data() {
    return {
      immeadiateHighlight: undefined
    }
  },
  computed: {
    icon() {
      return this.isHighlighted ? 'icStarFilled' : 'icStarOutlined'
    },
    tooltipText() {
      return this.isHighlighted
        ? 'Remover favorito do canal'
        : 'Favoritar canal'
    },
    shouldHighlight() {
      if (this.immeadiateHighlight !== undefined) {
        return this.immeadiateHighlight
      }

      return this.isHighlighted
    }
  },
  watch: {
    isHighlighted() {
      this.immeadiateHighlight = undefined
    }
  },
  methods: {
    toggleChannelHighlight() {
      this.immeadiateHighlight = !this.isHighlighted
      this.$store.dispatch(
        'pillars/channel/toggleChannelHighlight',
        this.channelId
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.highlightDefault {
  padding: 0 !important;
  color: var(--sys-color-content-primary);
}

.highlightButton {
  padding: var(--gl-spacing-03) !important;
  border-radius: 0;
  color: var(--sys-color-content-primary);
}

.highlighted {
  color: var(--gl-color-shades-yellow-60);
}
</style>
